import { AxiosResponse } from "axios";
import { call, put, select, takeLatest } from "redux-saga/effects";
import { AppService } from "src/services/app";
import { getBaseUrl } from "../selectors/features/app";
import {
  postAutoresponderKeywordFailure,
  postAutoresponderKeywordSuccess,
} from "../slices/features/postAutoresponderKeyword";
import { RequestTypes } from "../types";

const appservice = new AppService();

function* postAutoresponderKeywordSaga(action: any) {
  const { payload } = action;
  const { id, data } = payload;
  try {
    const baseUrl: string = yield select(getBaseUrl);

    const response: AxiosResponse<any> = yield call(
      appservice.postAutoresponderKeyword,
      baseUrl,
      id,
      data
    );

    yield put(postAutoresponderKeywordSuccess({ ...response }));
    payload?.cbSuccess && payload?.cbSuccess();
  } catch (error: any) {
    const { statusCode, statusText } = error;

    const message = error?.data?.errors?.message;

    payload?.cbFailure && payload?.cbFailure(message);

    yield put(postAutoresponderKeywordFailure({ statusCode, statusText }));
  }
}

export function* watchPostAutoresponderKeyword() {
  yield takeLatest(
    RequestTypes.POST_AUTORESPONDER_KEYWORD_REQUEST,
    postAutoresponderKeywordSaga
  );
}
